import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { useNavigate } from "react-router-dom";
import { StatCard } from "./resellerUi";

const MyCustomers = ({ customers }) => {
  const commercial = sessionStorage.getItem("commercial");
  const navigate = useNavigate();

  function handleClick() {
    sessionStorage.setItem("selectedTab", "Customer Management");
    navigate("/reseller/myC/customers");
  }

  return (
    <StatCard
      icon={GroupsOutlinedIcon}
      label="Customers"
      value={customers ?? 0}
      onClick={commercial === "true" ? undefined : handleClick}
    />
  );
};

export default MyCustomers;
